import React, { Component } from 'react'
import { connect } from 'react-redux'
import { DatePicker, Input, InputNumber, Row, Col, Select, Icon } from 'antd'
import moment from 'moment';

const Option = Select.Option;
class OvertimeStarTimeItem extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      err: false,
      data: {
        date: '',
        start: '',
        end: '',
        workTimes: ''
      }
    };
  }
  componentWillMount() {
    this.setState({ data: this.props.value });
  }

  componentWillReceiveProps(props) {
    this.setState({ data: props.value });
    if (props.hasError) {
      this.setState({ err: this.checkError() });
    }
  }

  checkError = () => {
    return !this.state.data.date || !this.state.data.start || !this.state.data.end || !this.state.data.workTimes;
  }


  dayChange = (day, dateString) => {
    let parame = this.state.data;
    parame.date = dateString;
    this.setState({ data: parame }, this.callback);
  }

  startHourChange = (hour) => {
    let parame = this.state.data;
    parame.start = hour;
    this.setState({ data: parame }, this.callback);
  }

  endHourChange = (hour) => {
    let parame = this.state.data;
    parame.end = hour;
    this.setState({ data: parame }, this.callback);
  }

  workHours = (hour) => {
    console.log(hour);
    let parame = this.state.data;
    if (hour) {
      hour = parseInt(hour.toString().replace(/\D/g, ''));
    }
    parame.workTimes = hour || '';
    this.setState({ data: parame }, this.callback);
  }

  callback = () => {
    if (this.props.dateChange) {
      this.props.dateChange(Object.assign({}, this.state.data, { index: this.props.index }));
      if (this.props.hasError) {
        this.setState({ err: this.checkError() });
      }
    }
  }

  render() {
    const { index, onDelete, itemLength, value } = this.props;
    console.log('itemLength----', itemLength)
    const generalTime = (str) => {
      const hours = [];
      for (let i = 0; i < 24; i++) {
        let time = '';
        let time2 = '';
        if (i < 10) {
          time = '0' + i + ':00';
          time2 = '0' + i + ':30';

        }
        else {
          time = i + ':00';
          time2 = i + ':30';
        }
        hours.push(
          <Option searchValue={time} key={str + i + '00' + index}
            value={time}>{time}</Option>);
        hours.push(
          <Option searchValue={time2} key={str + i + '30' + index}
            value={time2}>{time2}</Option>);
      }
      hours.push(
        <Option searchValue={23 + ':59'} key={str + 23 + '59' + index}
          value={23 + ':59'}>{23 + ':59'}</Option>);
      return hours;
    }
    return (
      <div className="overtime-apple-modal-time-item">
        <Row gutter={16} style={{ marginBottom: 10 }}>
          <Col span={10}>
            <DatePicker showTime={false}
              format='YYYY-MM-DD' style={{ width: '100%' }}
              onChange={this.dayChange}
              value={this.state.data.date ? moment(this.state.data.date) : undefined}
            />
          </Col>
          <Col span={6}>
            <Select
              style={{ width: '100%' }}
              onChange={this.startHourChange}
              placeholder='起始时间'
              optionFilterProp="children"
              value={this.state.data.start ? this.state.data.start.toString() : undefined}
            >
              {
                generalTime('start')
              }
            </Select>
          </Col>

          <Col span={6}>
            <Select
              style={{ width: '100%' }}
              onChange={this.endHourChange}
              placeholder='结束时间'
              optionFilterProp="children"
              defaultValue={value.end}
              value={this.state.data.end ? this.state.data.end.toString() : undefined}
            >
              {
                generalTime('end')
              }
            </Select>
          </Col>
          <Col span={2} onClick={(e) => onDelete(index)}>
            {
              itemLength > 1 ? (
                <Icon type="delete" />
              ) : null
            }

          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <InputNumber min={1} step={1} placeholder="手动输入小时数"
              value={this.state.data.workTimes}
              style={{ width: 150 }} onChange={this.workHours} />
          </Col>
        </Row>
        {
          this.state.err ? (
            <p className="error">请填写完整</p>
          ) : null
        }
      </div>
    );
  }
}
export default OvertimeStarTimeItem;



// WEBPACK FOOTER //
// ./src/components/process/formWrapper/overtimeStarTimeItem.js